import environment from '../../../environment/env.dev';
import { initUserClaims } from '../../components/contexts/JwtCreationContext';
import * as jose from 'jose';

const secret = new TextEncoder().encode('[B@3b07d329');
const alg = 'HS512';
export const createFakeJwt = async () => {
    const claims = {
        aud: initUserClaims.aud,
        authorization_group: initUserClaims.authorization_group,
        client_id: initUserClaims.client_id,
        email: initUserClaims.email,
        entitlement_group: [...initUserClaims.entitlement_group],
        family_name: initUserClaims.family_name,
        given_name: initUserClaims.given_name,
        sub: initUserClaims.sub,
    };

    return await new jose.SignJWT(claims)
        .setProtectedHeader({ alg })
        .setIssuer(environment.ISSUER)
        .setExpirationTime(environment.EXPIRATION_TIME)
        .sign(secret);
};
